import { render, staticRenderFns } from "./promotions-viewer.vue?vue&type=template&id=c8ba851a&scoped=true"
import script from "./promotions-viewer.vue?vue&type=script&lang=js"
export * from "./promotions-viewer.vue?vue&type=script&lang=js"
import style0 from "./promotions-viewer.vue?vue&type=style&index=0&id=c8ba851a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ba851a",
  null
  
)

export default component.exports